export default __webpack_public_path__ + "static/media/Flip.7aaf19f0.svg";